/** Settings & staff (§3, §16.2, §17.1) — registered through the append-only registry (docs/modules/console.md). */
import type { ConsoleRoute } from '../index';
import { StaffPage } from './StaffPage';

/** No `handle.permission`: the identity routes gate by role (ORGANIZER_ADMIN / PLATFORM_SUPER_ADMIN), the page too. */
export const settingsRoutes: ConsoleRoute[] = [
  { path: 'settings', handle: { title: 'Settings & staff' }, element: <StaffPage /> },
];
